import { db } from '../firebase'

export async function getUser(tel: string, email: string): Promise<any> {
  const docRef = db.collection('users').doc(email);
  const doc = await docRef.get()
  if (doc) {
    const user = doc.data()
    if (user) {
      console.log("user", user)
      return user
    }
  } else {
    console.log("no such doc")
  }
}
